function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { some, capitalize, toUpper } from 'lodash';
import noop from "../../utils/noop";
import { SEARCH_TYPES } from "../../constants";
import Attention from "../../icon-components/attention";
import Search from "../../icon-components/search";
import SelectInput from "../../components/select-input";
import LoadingIndicator from "../../loading-indicator";
import SearchResultOption from "./search-result-option";

var SearchResults =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchResults, _Component);

  function SearchResults() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchResults)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "isTrackSearch", function (searchName) {
      return searchName === SEARCH_TYPES.TRACKS;
    });

    _defineProperty(_assertThisInitialized(_this), "menuRenderer", function (searchError, query, tags, searchName, formatMessage, messages) {
      if (searchError) return _this.renderSearchError(formatMessage, messages);
      var searchResultsHeadingLabel = messages.searchResultsHeadingLabel;
      return function (_ref) {
        var _ref$options = _ref.options,
            options = _ref$options === void 0 ? [] : _ref$options,
            onSelect = _ref.onSelect,
            focusOption = _ref.focusOption,
            focusedOption = _ref.focusedOption;
        if (!query) return null;
        return [React.createElement("div", {
          key: 0,
          className: "SearchResults-heading"
        }, formatMessage(searchResultsHeadingLabel, {
          searchName: searchName,
          searchNameDisplay: capitalize(searchName),
          searchNameUpper: toUpper(searchName)
        }))].concat(_toConsumableArray(options.map(function (option, i) {
          var _cx;

          var isSelected = _this.isTrackSearch(searchName) ? some(tags, function (tag) {
            return tag.isrc === option.isrc;
          }) : some(tags, function (tag) {
            return tag.artistId === option.artistId;
          });
          var isFocused = option === focusedOption;
          var className = cx((_cx = {
            'Select-option': true
          }, _defineProperty(_cx, "Select-".concat(searchName), true), _defineProperty(_cx, 'is-selected', isSelected), _defineProperty(_cx, 'is-focused', isFocused), _cx));
          return React.createElement(SearchResultOption, _extends({
            key: i + 1,
            option: option,
            className: className,
            onFocus: focusOption,
            onSelect: onSelect,
            query: query,
            searchName: searchName
          }, option));
        })));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "buildOptions", function () {
      var _this$props = _this.props,
          options = _this$props.options,
          searchName = _this$props.searchName;

      var isTrackSearch = _this.isTrackSearch(searchName);

      return options.map(function (_ref2, index) {
        var isrc = _ref2.isrc,
            trackName = _ref2.trackName,
            artistId = _ref2.artistId,
            artistName = _ref2.artistName,
            imageUrl = _ref2.imageUrl,
            releaseName = _ref2.releaseName,
            upc = _ref2.upc;
        return {
          index: index,
          artistId: artistId,
          artistName: artistName,
          imageUrl: imageUrl,
          isrc: isrc,
          upc: upc,
          trackName: trackName,
          releaseName: releaseName,
          value: isTrackSearch ? isrc : artistId,
          label: isTrackSearch ? trackName : artistName
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderValueComponent", function (props) {
      return React.createElement("span", {
        className: "TagsInput-tag"
      }, props.value.trackName || props.value.artistName, React.createElement("a", {
        className: "TagsInput-remove",
        onClick: function onClick() {
          return props.onRemove(props.value);
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNoResultsOrLoading", function (query, searchName, isLoading, formatMessage, messages) {
      if (!query) return null;
      var searchResultsHeadingLabel = messages.searchResultsHeadingLabel,
          noMatchLabel = messages.noMatchLabel,
          checkSpellingLabel = messages.checkSpellingLabel;
      if (isLoading) return [React.createElement("div", {
        key: 0,
        className: "SearchResults-heading"
      }, formatMessage(searchResultsHeadingLabel, {
        searchName: searchName,
        searchNameDisplay: capitalize(searchName),
        searchNameUpper: toUpper(searchName)
      })), React.createElement("div", {
        key: 1,
        className: "SearchResultsLoadingIndicator"
      }, React.createElement(LoadingIndicator, null))];
      return React.createElement("div", null, React.createElement("h5", {
        className: "Search-no-results-label"
      }, formatMessage(noMatchLabel, {
        query: query,
        searchName: searchName,
        searchNameUpper: toUpper(searchName)
      })), React.createElement("h5", {
        className: "Search-no-results-label"
      }, formatMessage(checkSpellingLabel)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSearchError", function (formatMessage, messages) {
      return function () {
        var tryAgainLabel = messages.tryAgainLabel,
            temporaryErrorLabel = messages.temporaryErrorLabel,
            searchErrorLabel = messages.searchErrorLabel;
        return React.createElement("div", {
          className: "SearchError"
        }, React.createElement("h5", {
          className: "SearchError-label"
        }, React.createElement(Attention, null), React.createElement("span", {
          className: "Bolder"
        }, formatMessage(searchErrorLabel))), React.createElement("h5", {
          className: "SearchError-label"
        }, formatMessage(temporaryErrorLabel)), React.createElement("h5", {
          className: "SearchError-label"
        }, formatMessage(tryAgainLabel)));
      };
    });

    return _this;
  }

  _createClass(SearchResults, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          query = _this$props2.currentSearch,
          onInputChange = _this$props2.onInputChange,
          onChange = _this$props2.onChange,
          searchError = _this$props2.searchError,
          isLoading = _this$props2.isLoading,
          tags = _this$props2.tags,
          searchName = _this$props2.searchName,
          formatMessage = _this$props2.formatMessage,
          messages = _this$props2.messages;
      var dropdownOptions = this.buildOptions();
      var searchPlaceholderLabel = messages.searchPlaceholderLabel,
          searchArtistsPlaceholderLabel = messages.searchArtistsPlaceholderLabel;
      /* KEEP THE PROPERTIES ALPHABETICAL PLEASE */

      return React.createElement("div", {
        className: "SearchResults-wrapper"
      }, React.createElement("div", {
        className: "SearchResults SearchResults-with-artist-track-dropdown"
      }, React.createElement(SelectInput, {
        arrowRenderer: noop,
        cache: false,
        className: cx({
          'SearchResults-no-query': !query,
          'SearchResults-loading': isLoading,
          'SearchResults-with-dropdown': true
        }),
        filterOptions: false,
        menuRenderer: this.menuRenderer(searchError, query, tags, searchName, formatMessage, messages),
        multi: true,
        noResultsText: this.renderNoResultsOrLoading(query, searchName, isLoading, formatMessage, messages),
        onBlurResetsInput: false,
        onChange: onChange,
        onInputChange: onInputChange,
        options: dropdownOptions,
        placeholder: this.isTrackSearch(searchName) ? formatMessage(searchPlaceholderLabel) : formatMessage(searchArtistsPlaceholderLabel),
        scrollMenuIntoView: false,
        searchable: true,
        value: tags,
        valueComponent: this.renderValueComponent
      }), React.createElement(Search, null)));
    }
  }]);

  return SearchResults;
}(Component);

_defineProperty(SearchResults, "propTypes", {
  options: PropTypes.array,
  currentSearch: PropTypes.string,
  onInputChange: PropTypes.func,
  onChange: PropTypes.func,
  searchError: PropTypes.string,
  isLoading: PropTypes.bool,
  tags: PropTypes.array,
  searchName: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.shape({
    searchResultsHeadingLabel: PropTypes.object,
    noMatchLabel: PropTypes.object,
    searchPlaceholderLabel: PropTypes.object,
    searchArtistsPlaceholderLabel: PropTypes.object,
    tryAgainLabel: PropTypes.object,
    temporaryErrorLabel: PropTypes.object,
    searchErrorLabel: PropTypes.object,
    checkSpellingLabel: PropTypes.object,
    releasedDateLabel: PropTypes.object,
    releaseNameLabel: PropTypes.object
  }).isRequired
});

_defineProperty(SearchResults, "defaultProps", {
  options: [],
  currentSearch: '',
  onInputChange: noop,
  onChange: noop,
  searchError: null,
  isLoading: false,
  tags: [],
  searchName: SEARCH_TYPES.ARTISTS
});

export default SearchResults;